/* eslint-disable import/no-anonymous-default-export */

import Divider from "../../baseComponents/divider/Divider";
import Section from "../../baseComponents/section/Section";
import { useTranslation } from "react-i18next";

export default (
) => {
    const { t } = useTranslation();
    const { i18n: { language } } = useTranslation();
    const jl = language === 'en' ? 'md:h-32 xl:h-48' : 'md:h-40 xl:h-72 '

    return (
        <Divider cl="bg-black  ">
            <div className="grid md:grid-cols-3  lg:gap-16 xl:gap-8 text-white   items-center  ">

                <Section title={t('Easy_fast')} text={t("Easy_fast_T")} cl={" md:text-3xl xl:text-6xl " + jl} ic={true} />
                <Section title={t('Privacy_security')} text={t("Privacy_security_T")} cl={"  md:text-3xl xl:text-6xl " + jl} ic={true} />
                <Section title={t('Online_payments')} text={t("Online_payments_T")} cl={" md:text-3xl xl:text-6xl " + jl} ic={true} />

            </div>
        </Divider>
    );
};
